import React from "react";
import { getAllSiteDrafts } from "../../api/index";
import { Table, Spin, Select } from "antd";
import { useHistory } from 'react-router-dom';
import moment from "moment";

const AllDrafts = () => {

    const [drafts, setDrafts] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [selectedSite, setSelectedSite] = React.useState(null);

    const history = useHistory();

    React.useEffect(() => {
        const fetchDrafts = async () => {
            setLoading(true);
            try {
                const response = await getAllSiteDrafts();
                setDrafts(response?.data || []);
            } catch (error) {
                console.error("Error fetching drafts:", error);
            }
            setLoading(false);
        };
        fetchDrafts();
    }, []);

    const siteOptions = React.useMemo(() => {
        return drafts.map(d => ({
            value: String(d.siteN360Id || d.id),
            label: `${d.siteName || 'Unknown'} (${d.siteN360Id || d.id})`,
            // keep original data for potential use
            _raw: d
        }));
    }, [drafts]);

    const filteredDrafts = React.useMemo(() => {
        if (!selectedSite) return drafts;
        const selVal = String(selectedSite);
        return drafts.filter(d => String(d.siteN360Id || d.id) === selVal);
    }, [drafts, selectedSite]);

    const cols = [
        { title: "Site N360 ID", dataIndex: "siteN360Id", key: "siteN360Id" },
        { title: "Site Name", dataIndex: "siteName", key: "siteName" },
        { title: "Missing Count", dataIndex: "missingCount", key: "missingCount", render: (text, record) => record?.missingFields ? record?.missingFields.split(",").length : 0 },
        { title: "Missing Fields", dataIndex: "missingFields", key: "missingFields" },
        {
            title: "Created On", dataIndex: "createdOn", key: "createdOn",
            render: (text) => text ? moment(text).format("DD-MM-YYYY HH:mm") : "N/A"
        },
        {
            title: "Updated On", dataIndex: "updatedOn", key: "updatedOn",
            render: (text) => text ? moment(text).format("DD-MM-YYYY HH:mm") : "N/A"
        },
    ]

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="page-title-box">
                        <div className="row">
                            <div className="col">
                                <h4 className="page-title">
                                    <span className="textStyles-small" style={{ fontSize: 16 }}>All Drafts</span>
                                </h4>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">
                                            <span className="textStyles-small" style={{ fontSize: 12 }}>Site View</span>
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">
                                            <span className="textStyles-small" style={{ fontSize: 12 }}>All Drafts</span>
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ backgroundColor: 'white', borderRadius: 15 }}>
                <div style={{ padding: '20px 20px 20px 20px' }}>

                    <div style={{ marginBottom: 16, width: '400px', float: 'right' }}>
                        <Select
                            showSearch
                            allowClear
                            placeholder="Search by site name or site id..."
                            options={siteOptions}
                            value={selectedSite}
                            bordered={false}
                            className='borderedSelect textStyles-small'
                            style={{ width: '400px', height: 38 }}
                            onChange={(val) => setSelectedSite(val)}
                            filterOption={(input, option) => {
                                const label = (option?.label || '').toString().toLowerCase();
                                const value = (option?.value || '').toString().toLowerCase();
                                return label.includes(input.toLowerCase()) || value.includes(input.toLowerCase());
                            }}
                        />
                    </div>

                    <Table
                        columns={cols}
                        dataSource={filteredDrafts}
                        className="table-striped-rows textStyles-small clickable-row"
                        rowKey="id"
                        loading={loading ? { indicator: <Spin size="large" /> } : false}
                        pagination={{ pageSize: drafts.length > 10 ? 10 : drafts.length }}
                        onRow={(record) => ({
                            onClick: () => history.push(`/data-collection/draft-editor/${record.id}`),
                        })}
                        rowClassName={() => 'cursor-pointer'}
                    />
                </div>



            </div>

        </div>
    );
};

export default AllDrafts;